import { Carousel } from "antd-mobile";
import { appMethod as app } from '@utils/app';

import { getCurrentPageQueryParams, convertLineStyleData } from '@utils/tools';
import OfficialPage from '../OfficialPage';
import { TopNav } from '@common/top-nav/TopNav';
import './ExtensionPage.less';

export default class ExtensionPage extends OfficialPage {
  state = {
    appTitle: '',
    appLogo: '',
    extensionId: '', // 推广页id
    extensionItemData: {}, // 推广页面配置信息
    currentPage: ''
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    this.setData({
      appTitle: app.globalData.appTitle,
      appLogo: app.globalData.appLogo,
      extensionId: options.extension_id,
      currentPage: options.current_page || 'home'
    })
    this.dataInitial()
  }

  dataInitial = () => {
    this.getExtensionPageData(this.data.extensionId)
  }
  getExtensionPageData = id => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=AppExtensionInfo/getOneExtensionInfo',
      data: {
        id: id
      },
      hideLoading: true,
      success: function(res) {
        let configData = JSON.parse(res.data.config_data)
        that.setData({
          extensionItemData: configData
        })
        app.setPageTitle(that.data.appTitle || '即速应用 webapp')
      }
    })
  }
  jumpToHome = () => {
    let router = app.globalData.homepageRouter
    let url = '/' + router
    app.turnToPage(url, true)
  }
  jumpToPage = event => {
    let url = event.currentTarget.dataset.pageUrl
    app.turnToPage(url, false)
  }
  jumpToRouter = event => {
    let router = event.currentTarget.dataset.pageUrl
    let url = '/' + router
    app.turnToPage(url, false)
  }
  copyWifiPassword = () => {
    app.setClipboardData({
      data: this.data.extensionItemData['wifi']['wifi_password'],
      success: function(res) {
        app.showToast({
          title: '复制成功',
          success: function() {}
        })
      }
    })
  }
  showWifiPage = () => {
    let router = 'extensionPage'
    let url =
      '/extensionPage?extension_id=' +
      this.data.extensionId +
      '&current_page=wifi'
    app.turnToPage(url, false)
  }

  render() {
    const {
      appLogo,
      appTitle,
      extensionItemData,
      currentPage
    } = this.state
    return (
      <div className="official-page extension-page">
        <TopNav title="推广" />
        <div className="extensionPage-wrap page" id="extensionPage">
          {currentPage == 'home' ? (
            <div className="home-page">
              <div className="goto-home-item" onClick={this.jumpToHome}>
                <img className="app-logo" src={appLogo} />
                <span className="app-title">{appTitle}</span>
                <span className="tip">进入首页</span>
                <div className="ico-moon icon-rightarrow"></div>
              </div>
              {/* 主要推广 */}
              {extensionItemData['wifi'] && extensionItemData['wifi']['show'] == 1 &&
              extensionItemData['wifi']['is_main'] == 1 ? (
                <div className="main-extension-item wifi">
                  <div className="wifi-setting">
                    <span className="setting-field">Wi-Fi名称:</span>
                    <span className="setting-text">
                      {extensionItemData['wifi']['wifi_name']}
                    </span>
                  </div>
                  <div className="wifi-setting">
                    <span className="setting-field">Wi-Fi密码:</span>
                    <span className="setting-text">
                      {extensionItemData['wifi']['wifi_password']}
                    </span>
                    <div
                      className="copy-password"
                      onClick={this.copyWifiPassword}
                    >
                      复制
                    </div>
                  </div>
                </div>
              ) : extensionItemData['facetoface_pay'] && extensionItemData['facetoface_pay']['show'] == 1 &&
              extensionItemData['facetoface_pay']['is_main'] == 1 ? (
                <div
                  className="main-extension-item facetoface-pay"
                  data-page-url="/eCommerce/pages/transferPage/transferPage"
                  onClick={this.jumpToPage}
                >
                  <div className="main-item-icon">
                    <div className="ico-moon icon-facetoface-pay"></div>
                  </div>
                  <span className="main-item-name">面对面付款</span>
                  <span className="main-item-tip">立即前往</span>
                  <div className="ico-moon icon-rightarrow"></div>
                </div>
              ) : extensionItemData['coupon'] && extensionItemData['coupon']['show'] == 1 &&
              extensionItemData['coupon']['is_main'] == 1 ? (
                <div
                  className="main-extension-item coupon"
                  data-page-url="/eCommerce/pages/couponList/couponList"
                  onClick={this.jumpToPage}
                >
                  <div className="main-item-icon">
                    <div className="ico-moon icon-coupon"></div>
                  </div>
                  <span className="main-item-name">优惠券</span>
                  <span className="main-item-tip"></span>
                  <div className="ico-moon icon-rightarrow"></div>
                </div>
              ) : (
                extensionItemData['vip_card'] && extensionItemData['vip_card']['show'] == 1 &&
                extensionItemData['vip_card']['is_main'] == 1 && (
                  <div
                    className="main-extension-item vip-card"
                    data-page-url="/eCommerce/pages/vipCard/vipCard"
                    onClick={this.jumpToPage}
                  >
                    <div className="main-item-icon">
                      <div className="ico-moon icon-vip-card"></div>
                    </div>
                    <span className="main-item-name">会员卡</span>
                    <span className="main-item-tip"></span>
                    <div className="ico-moon icon-rightarrow"></div>
                  </div>
                )
              )}
              {/* 推广项 */}
              <div className="extension-item-list">
                {extensionItemData['wifi'] && extensionItemData['wifi']['show'] == 1 &&
                extensionItemData['wifi']['is_main'] == 0 && (
                  <div
                    className="extension-item"
                    onClick={this.showWifiPage}
                  >
                    <div className="item-icon ico-moon icon-wifi"></div>
                    <span className="item-text">Wi-Fi</span>
                    <div className="ico-moon icon-rightarrow"></div>
                  </div>
                )}
                {extensionItemData['facetoface_pay'] && extensionItemData['facetoface_pay']['show'] == 1 &&
                extensionItemData['facetoface_pay']['is_main'] == 0 && (
                  <div
                    className="extension-item"
                    data-page-url="/eCommerce/pages/transferPage/transferPage"
                    onClick={this.jumpToPage}
                  >
                    <div className="item-icon ico-moon icon-facetoface-pay"></div>
                    <span className="item-text">面对面付款</span>
                    <div className="ico-moon icon-rightarrow"></div>
                  </div>
                )}
                {extensionItemData['coupon'] && extensionItemData['coupon']['show'] == 1 &&
                extensionItemData['coupon']['is_main'] == 0 && (
                  <div
                    className="extension-item"
                    data-page-url="/eCommerce/pages/couponList/couponList"
                    onClick={this.jumpToPage}
                  >
                    <div className="item-icon ico-moon icon-coupon"></div>
                    <span className="item-text">优惠券</span>
                    <div className="ico-moon icon-rightarrow"></div>
                  </div>
                )}
                {extensionItemData['vip_card'] && extensionItemData['vip_card']['show'] == 1 &&
                extensionItemData['vip_card']['is_main'] == 0 && (
                  <div
                    className="extension-item"
                    data-page-url="/eCommerce/pages/vipCard/vipCard"
                    onClick={this.jumpToPage}
                  >
                    <div className="item-icon ico-moon icon-vip-card"></div>
                    <span className="item-text">会员卡</span>
                    <div className="ico-moon icon-rightarrow"></div>
                  </div>
                )}
              </div>
              {/* 广告图 */}
              {extensionItemData['advert_img'] && extensionItemData['advert_img']['show'] == 1 && (
                <div className="advert-img-item">
                  <Carousel
                    autoplay={true}
                  >
                    {extensionItemData['advert_img']['img_list'].map((val, index) => (
                      <a
                        key={index}
                        style={{ display: 'inline-block', width: '100%', height: '1.95rem' }}
                      >
                        <img
                          src={val['url']}
                          className="slide-image"
                          mode="widthFix"
                          onClick={this.jumpToRouter}
                          data-page-url={val['link']}
                          style={{ width: '100%', verticalAlign: 'top', height: '100%' }}
                        />
                      </a>
                    ))}
                  </Carousel>
                </div>
              )}
              </div>
          ) : (
          currentPage == 'wifi' && (
          <div className="second-page">
          {extensionItemData['wifi'] && extensionItemData['wifi']['show'] == 1 && (
            <div className="main-extension-item wifi">
              <div className="wifi-setting">
                <span className="setting-field">Wi-Fi名称:</span>
                <span className="setting-text">
                  {extensionItemData['wifi']['wifi_name']}
                </span>
              </div>
              <div className="wifi-setting">
                <span className="setting-field">Wi-Fi密码:</span>
                <span className="setting-text">
                  {extensionItemData['wifi']['wifi_password']}
                </span>
                <div
                  className="copy-password"
                  onClick={this.copyWifiPassword}
                >
                  复制
                </div>
              </div>
            </div>
          )}
          </div>)
          )}
        {/* 推广页二级页面 */}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/extension-page/ExtensionPage.jsx